<template>
    <div class="rating-star">
        <custom-icon v-if="value < 0.17" size="m" name="rating_star_border" />
        <custom-icon v-if="value >= 0.17 && value < 0.4" size="m" name="rating_star_third" />
        <custom-icon v-if="value >= 0.4 && value <= 0.6" size="m" name="rating_star_half" />
        <custom-icon v-if="value > 0.6 && value <= 0.83" size="m" name="rating_star_2third" />
        <custom-icon v-if="value > 0.83" size="m" name="rating_star" />
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.rating-star {
    display: flex;
    align-items: center;
    font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/RatingStar.vue